// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Image from 'church-theme-library/components/Image/Image'

class AdvertisementAwr extends React.Component {
	render() {
		return (
			<div className="section-advertisement-general section-advertisement-awr">
				<div className="-inner">
					<div className="-image">
						<a href="https://awr.org/" target="_blank" rel="noopener">
							<Image
								thumb={ `${siteData.images_url}sections/external/awr-thumb.jpg` }
								url={ `${siteData.images_url}sections/external/awr.jpg` }
								srcset={ null }
								sizes={ `(max-width: ${siteData.mobile_max_width}px) 100vw, 1100px` }
								alt="Adventist World Radio"
								width={ 1200 }
								height={ 1563 }
							/>
						</a>
					</div>
				</div>
			</div>
		)
	}
}

export default AdvertisementAwr
